import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import VueQuillEditor from 'vue-quill-editor';
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);
// element
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import Echarts from 'echarts';
Vue.prototype.$echarts=Echarts;
import '@/assets/js/onelresize.js';
import Mixins from './Mixin/index.js';
Vue.mixin(Mixins);
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
